<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.scenarios" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title class="--logo">
      <a class="header__logo" [routerLink]="['/']">
        <app-logo></app-logo>
      </a>
      <span [innerHTML]="'SCENARIOS.DETAILS' | translate"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-avatar class="header__avatar" [routerLink]="['..', '..', routes.settings]">
        <img class="header__avatar__image" src="/assets/avatar/anna.svg" [alt]="(user$ | async)?.firstName" />
      </ion-avatar>
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="scenario">
  <ul class="scenario__tabs">
    <li
      class="scenario__tabs__item"
      *ngFor="let tab of tabs; let i = index"
      [class.--active]="tab.active"
      [innerHTML]="tab.name"
      (click)="activeTab(i)"
    ></li>
  </ul>
  <div *ngIf="tabs[0].active" class="white-wrapper --flow" [innerHTML]="loading$|async|toTree:(scenario$|async)|async"></div>
  <div *ngIf="tabs[1].active" class="white-wrapper">
    <ion-list class="scenario__history-list">
      <ion-item *ngFor="let run of history$ | async" (click)="openLogs(run)">
        <div class="scenario__history-list__item">
          <span class="scenario__history-list__item__title" [innerHTML]="run.date | date: 'dd. MMMM YYYY HH:mm'"></span>
          <p
            class="scenario__history-list__item__text"
            [innerHTML]="'SCENARIOS.RUN.DESCRIPTION' | translate:{ runId: run.runId, context: run.isManual ? run.context : '', runType: (run.isManual ? 'SCENARIOS.RUN.MANUAL' : 'SCENARIOS.RUN.AUTOMATIC') | translate }"
          ></p>
        </div>
      </ion-item>

      <ion-item *ngIf="!(history$|async)?.length">
        <div class="scenario__history-list__item">
          <span class="scenario__history-list__item__title" [innerHTML]="'SCENARIOS.NO_RUNS_TO_DISPLAY' | translate"></span>
        </div>
      </ion-item>
    </ion-list>

    <ion-infinite-scroll
      [disabled]="(currentHistoryTotalPages$ | async) <= (currentHistoryPage$ | async)"
      (ionInfinite)="loadMoreRuns($any($event))"
    >
      <ion-infinite-scroll-content color="primary" [loadingText]="'LOADING' | translate"></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>
</ion-content>
